import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from "@stripe/react-stripe-js";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#000",
      fontFamily: "Sora, sans-serif",
      fontSize: "14px",
      fontWeight: 400,
      "::placeholder": {
        color: "#8E8E8E",
      },
    },
    invalid: {
      color: "#CC0000",
      iconColor: "#CC0000",
    },
  },
};

export enum EElementType {
  CVC = "cvc",
  Number = "number",
  Expiry = "expiry",
}

interface IStripeInputElement {
  type: EElementType;
}

const labels = {
  cvc: "Card CVC",
  number: "Card Number",
  expiry: "Card Date Expiration",
};

export const StripeInputElement = ({ type }: IStripeInputElement) => {
  return (
    <div className="mb-2">
      <span
        className="flex font-sora text-sm mb-2"
        style={{
          fontStyle: "normal",
          fontWeight: 400,
          color: "#A5A5A5",
        }}
      >
        {labels[type]}
      </span>
      <div className="flex items-center p-3 border-[0.5px] border-bt-gray-500 placeholder:text-base text-bt-dark-gray-transparent placeholder:font-sora rounded w-full h-14 text-sm font-sora ">
        {type === EElementType.Number && (
          <CardNumberElement
            options={CARD_ELEMENT_OPTIONS}
            className="w-full"
          />
        )}
        {type === EElementType.CVC && (
          <CardCvcElement options={CARD_ELEMENT_OPTIONS} className="w-full" />
        )}
        {type === EElementType.Expiry && (
          <CardExpiryElement
            options={CARD_ELEMENT_OPTIONS}
            className="w-full"
          />
        )}
      </div>
    </div>
  );
};
